enum FormTypeId {
    Default = '-',
    Beds = 'beds',
    Blinds = 'blinds',
    Claustra = 'claustra',
    CounterBar = 'counterBar',
    DesignProject = 'designProject',
    Desk = 'desk',
    Door = 'door',
    Vegetal = 'vegetal',
    Fencing = 'fencing',
    GlassAndMirror = 'glassAndMirror',
    GlassWall = 'glassWall',
    Kitchen = 'kitchen',
    Library = 'library',
    Pergola = 'pergola',
    Storage = 'storage',
    Staircase = 'staircase',
    StorageUnit = 'storageUnit',
    Table = 'table',
    TableLegs = 'tableLegs',
    Terrace = 'terrace',
    Tray = 'tray',
    TvUnit = 'tvUnit',
    Wardrobe = 'wardrobe',
    WineCellar = 'wineCellar',
    WorkTop = 'workTop',
}

export default FormTypeId;
